import React, { useEffect, useState } from "react";
import { FaCircleChevronRight } from "react-icons/fa6";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Parts() {
  const navigate = useNavigate();
  const [parts, setParts] = useState([]);
  const [searchPartType, setSearchPartType] = useState("");
  const [searchRefNumber, setSearchRefNumber] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const response = await axios.get("https://backend.hira-tech.co.uk/inventory/api/manufacturing/");
        setParts(response.data);
        console.log("Fetched parts:", response.data);
      } catch (error) {
        console.error("Error fetching parts:", error);
      }
    };
    fetchParts();
  }, []);

  const filteredParts = parts.filter((part) => {
    const matchesPartType = searchPartType
      ? part.part_type.toLowerCase().includes(searchPartType.toLowerCase())
      : true;

    const matchesRefOrLot = searchRefNumber
      ? (
          (part.part_reference_number && part.part_reference_number.toLowerCase().includes(searchRefNumber.toLowerCase())) ||
          (part.lot_number && part.lot_number.toLowerCase().includes(searchRefNumber.toLowerCase())) ||
          (part.part_name && part.part_name.toLowerCase().includes(searchRefNumber.toLowerCase()))
        )
      : true;

    const matchesStartDate = startDate
      ? new Date(part.manufacturing_date) >= new Date(startDate)
      : true;

    const matchesEndDate = endDate
      ? new Date(part.manufacturing_date) <= new Date(endDate)
      : true;

    return matchesPartType && matchesRefOrLot && matchesStartDate && matchesEndDate;
  });

  return (
    <div className="order-container">
      <h2>Manufactured Parts</h2>

      <div className="search-row">
        <input
          type="text"
          className="search-bar"
          placeholder="Search by Reference No., Lot No. or Part Name"
          value={searchRefNumber}
          onChange={(e) => setSearchRefNumber(e.target.value)}
        />
        <input
          type="text"
          className="search-bar"
          placeholder="Search by Part Type"
          value={searchPartType}
          onChange={(e) => setSearchPartType(e.target.value)}
        />

      </div>

      <div className="filter-row">
        <input
          className="filter-item"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <input
          className="filter-item"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Manufacturing Date</th>
              <th>Lot Number</th>
              <th>Part Type</th>
              <th>Part Name</th>
              <th>Reference No.</th>
              <th>Operator</th>
              <th>Quantity</th>
              <th>Weight</th>
              <th>Machine No.</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredParts.map((part) => (
              <tr key={part.id}>
                <td>{part.manufacturing_date}</td>
                <td>{part.lot_number || "N/A"}</td>
                <td>{part.part_type}</td>
                <td>{part.part_name}</td>
                <td>{part.part_reference_number}</td>
                <td>{part.machine_operator}</td>
                <td>{part.quantity}</td>
                <td>{part.total_part_weight
                }</td>
                <td>{part.machine_number}</td>
                <td className="arrow-cell">
                  <button
                    className="navigate-button"
                    onClick={() => navigate(`/admin/lot-detail/${part.id}`)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    <FaCircleChevronRight
                      className="arrow-icon"
                      style={{ color: "#004aad", transition: "transform 0.3s ease-in-out" }}
                      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateX(5px)")}
                      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateX(0)")}
                    />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style jsx>{`
        .search-row, .filter-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 15px;
        }
        .search-bar, .filter-item {
          flex: 1;
          min-width: 200px;
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }
        .table-wrapper {
          overflow-x: auto;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }
        th, td {
          padding: 10px;
          border: 1px solid #ddd;
          text-align: left;
        }
        th {
          background: #004aad;
          color: white;
        }
        @media (max-width: 768px) {
          .search-row, .filter-row {
            flex-direction: column;
          }
          .search-bar, .filter-item {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
}